
const treatments = [
  {
    title: '鍼治療',
    description: '経絡理論に基づいた繊細な施術で、体の内側から不調を改善。肩こり・腰痛・頭痛など、様々な症状に対応します。',
    image: 'https://public.readdy.ai/ai/img_res/04c8ae338a59ec9e5335d120559e1268.jpg',
    bgColor: 'bg-sub',
  },
  {
    title: 'お灸治療',
    description: '温熱効果で血行を促進し、冷え性や慢性的な疲労を改善。心地よい温かさが体を癒します。',
    image: 'https://readdy.ai/api/search-image?query=Close-up%20of%20traditional%20Japanese%20moxa%20moxibustion%20therapy%2C%20warm%20glowing%20moxa%20cone%20on%20acupuncture%20point%2C%20gentle%20smoke%20rising%2C%20soft%20warm%20lighting%20creating%20cozy%20atmosphere%2C%20clean%20clinical%20setting%2C%20therapeutic%20warmth%20visualization%2C%20professional%20healthcare%20treatment%2C%20high%20quality%20detailed%20photography%2C%20focus%20on%20healing%20warmth&width=600&height=800&seq=treatment-moxibustion&orientation=portrait',
    bgColor: 'bg-accent/20',
  },
  {
    title: '美容鍼',
    description: '顔のツボを刺激し、リフトアップやシワ改善など、内側から美しさを引き出します。',
    image: 'https://readdy.ai/api/search-image?query=Serene%20Japanese%20woman%20in%20her%2030s%20receiving%20facial%20acupuncture%20treatment%2C%20delicate%20needles%20placed%20on%20face%20acupuncture%20points%2C%20lying%20peacefully%20on%20treatment%20bed%2C%20soft%20diffused%20lighting%2C%20clean%20modern%20aesthetic%20clinic%2C%20professional%20beauty%20therapy%20setting%2C%20natural%20rejuvenation%20concept%2C%20high%20quality%20beauty%20photography%2C%20gentle%20and%20elegant%20atmosphere&width=600&height=800&seq=treatment-beauty&orientation=portrait',
    bgColor: 'bg-primary/10',
  },
];

const TreatmentSection = () => {
  return (
    <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <div className="inline-block bg-sub px-4 py-1 rounded-full mb-4">
            <span className="text-primary text-xs font-medium tracking-wider uppercase">Treatment</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-primary mb-3 sm:mb-4 px-4">
            当院の<strong>施術内容</strong>
          </h2>
          <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto px-4">
            <strong>岡山市北区</strong>で一人ひとりの体質と症状に合わせた、オーダーメイドの<strong>鍼灸治療</strong>を提供しています
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
          {treatments.map((treatment, index) => (
            <article
              key={index}
              className={`${treatment.bgColor} rounded-2xl sm:rounded-3xl overflow-hidden group hover:shadow-xl transition-shadow duration-300 cursor-pointer`}
            >
              <div className="p-6 sm:p-8">
                <h3 className="font-serif text-xl sm:text-2xl text-gray-900 mb-4 text-center">{treatment.title}</h3>
                <div className="mb-4 h-48 sm:h-56 md:h-64">
                  <img
                    src={treatment.image}
                    alt={treatment.title}
                    className="w-full h-full object-cover rounded-xl sm:rounded-2xl"
                  />
                </div>
                <p className="text-gray-700 text-xs sm:text-sm leading-relaxed text-center">{treatment.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TreatmentSection;
